/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../../store/AuthContext';
import { useAppStore } from '../../../store/AppContext';
import { StorageHelper } from '../../../utils/StorageHelper';
import { TarjetaService } from '../../../services';
import useAPIError from '../../../hooks/useAPIError';
import { CookieHelper } from '../../../utils/CookieHelper';
import { HostProvider } from '../../../utils/HostProvider';
import { CryptoUtil } from '../../../utils/CryptoUtil';
import { BackMappings } from '../../../utils/BackMappings';

const TarjetaTemporalModificarCotitular: FC = () => {
  const { t } = useTranslation();
  const isCaprabo = HostProvider.isCaprabo();
  const dataUser = useAuthStore();
  const dataApp = useAppStore();
  const [cardNumberShort, setCardNumberShort] = useState<string>();
  const [controlDigit, setControlDigit] = useState<string>();
  const { addError, addErrorBack } = useAPIError();
  const [firstCharge, setFirstCharge] = useState(true);

  const getCardNumber = () => {
    TarjetaService.getTarjeta()
      .then((response) => {
        if (response.data.error) {
          if (
            firstCharge &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          addErrorBack(response.data);
        } else {
          setCardNumberShort(
            CryptoUtil.decryptAes(response.data.pojo.cardNumberShort),
          );
          setControlDigit(
            CryptoUtil.decryptAes(response.data.pojo.controlDigit),
          );
        }
        setFirstCharge(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };
  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
    }
  });

  return (
    <>
      <div className="u-display-flex-tablet u-justify-content-space-between">
        <div className="bloque-socio">
          <p className="title__medium u-margin-bottom-small">
            {t('tarjetas.tarjeta-club.no-card')}
          </p>
          <p>
            {t('tarjetas.tarjeta-club.download')}{' '}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${
                isCaprabo
                  ? process.env.REACT_APP_API_CAPRABO
                  : process.env.REACT_APP_API
              }/${dataApp.lang}/nlrVerTarjeta/html/${cardNumberShort}.html`}
              className="link link-demi"
            >
              {t('tarjetas.tarjeta-club.temporal-card')}
            </a>
          </p>
        </div>

        <div className="bloque-socio">
          <p className="title__medium u-margin-bottom-small">
            {t('tarjetas.tarjeta-club.change-card')}
          </p>
          <p>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href=""
              className="link link-demi"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                StorageHelper.deleteUserFromSession();
                CookieHelper.removeUserCookies();
                document.location.href = `${
                  isCaprabo
                    ? process.env.REACT_APP_API_CAPRABO
                    : process.env.REACT_APP_API
                }/${
                  dataApp.lang
                }/nlrRegistrar/titular/dadoalta/nocoincide/desdetarjetas?fromApp=${
                  dataUser.user.fromApp
                }&origenAP=tarjetas&TEC=${cardNumberShort}${controlDigit}`;
              }}
            >
              {t('tarjetas.tarjeta-club.update')}
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default TarjetaTemporalModificarCotitular;
